import React, { useState } from 'react'
import Sidebar from './Sidebar'
import Header from './Header'

function Layout({ children, title }) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(prevState => !prevState);
    };
    return (
        <>
            <div className='d-flex align-items-center gap-2'>
                <Sidebar isSidebarOpen={isSidebarOpen} onToggle={toggleSidebar} />
                <div className='w-100 overflow-auto'>
                    <Header title={title} onToggle={toggleSidebar} />
                    {children}
                </div>
            </div>
        </>
    )
}

export default Layout